import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setOtpRequest } from '../../store/authSlice';
import { requestOtp } from '../../api/auth.api';
import AuthLayout from '../../layouts/AuthLayout';
import Input from '../../components/common/Input';
import Button from '../../components/common/Button';
import Alert from '../../components/common/Alert';

const CandidateLogin = () => {
  const [form, setForm] = useState({ email: '', full_name: '', mobile: '', college_name: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await requestOtp(form);
      dispatch(setOtpRequest(form));
      navigate('/verify-otp');
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to send OTP. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout>
      <div className="mb-7">
        <div className="inline-flex items-center gap-2 bg-primary-50 text-primary-700 px-3 py-1 rounded-full text-xs font-semibold mb-3">
          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
          Candidate Portal
        </div>
        <h2 className="text-2xl font-bold text-slate-900 leading-tight">Get Started</h2>
        <p className="text-slate-500 text-sm mt-1">Enter your email to receive a one-time password</p>
      </div>

      {error && <Alert type="error" className="mb-5">{error}</Alert>}

      <form onSubmit={handleSubmit} className="space-y-1">
        <Input
          label="Full Name"
          type="text"
          placeholder="Your full name"
          value={form.full_name}
          onChange={(e) => setForm({ ...form, full_name: e.target.value })}
          required
        />
        <Input
          label="Email address"
          type="email"
          placeholder="you@example.com"
          value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
          required
        />
        <Input
          label="Mobile Number"
          type="tel"
          placeholder="+91 98765 43210"
          value={form.mobile}
          onChange={(e) => setForm({ ...form, mobile: e.target.value })}
          required
        />
        <Input
          label="College / Institution Name"
          type="text"
          placeholder="Your college or institution"
          value={form.college_name}
          onChange={(e) => setForm({ ...form, college_name: e.target.value })}
          required
        />
        <div className="pt-2">
          <Button type="submit" fullWidth size="lg" loading={loading}>
            {loading ? 'Sending OTP…' : 'Send OTP'}
          </Button>
        </div>
      </form>

      {/* Info note */}
      <div className="mt-5 bg-slate-50 rounded-xl px-4 py-3 border border-slate-100">
        <p className="text-xs text-slate-500 flex items-start gap-2">
          <svg className="w-4 h-4 text-slate-400 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
          A 6-digit OTP will be sent to your inbox. The code is valid for 10 minutes.
        </p>
      </div>

      <p className="text-center text-sm text-slate-400 mt-5">
        Are you an admin?{' '}
        <a href="/admin/login" className="text-primary-600 hover:text-primary-700 font-medium hover:underline">
          Admin Login
        </a>
      </p>
    </AuthLayout>
  );
};

export default CandidateLogin;
